export default __webpack_public_path__ + "static/media/logo.3dd6d48d.svg";